import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Aos from "aos";
import "./assets/styles/main.css";

import Home from './views/Home/Home';
import NotFoundPage from './views/404';
import "./i18n";

function App() {
  useEffect(() => {
    Aos.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <BrowserRouter>

      <Routes>
        <Route path="/">
          <Route index element={<Home />} />

          <Route path="/404" element={<NotFoundPage />} />
        </Route>
      </Routes>

    </BrowserRouter>
  );
}

export default App;
